module.exports = __webpack_public_path__ + "static/media/home_introduce_2.b6be069b.jpg";